/* assets/hub-reviews-badge.js - hub-owned floating reviews badge (ledger reviews-badge-theme-snippet-push).
   Board: docs/boards/reviews/reviews-badge-board.html (6a closed, 6b open, 6c phone sheet, 6d invite pill).
   Reference copy: docs/hub_reviews_badge.js. Pushed to assets/hub-reviews-badge.js on each store.

   Reads ONE small per-store JSON from the app proxy (/apps/hub/reviews/summary.json, cached 10 minutes by the
   hub) once per page view and renders into #hub-rvb (emitted by snippets/hub-reviews-badge.liquid):
     count >= threshold  -> pill "4.9 from 1,593 customers" that opens the panel (6a / 6b), bottom sheet on a phone (6c)
     count <  threshold  -> blue invite pill "New on Google - review us" linking to the store's review page (6d)
     anything else (blocked, non-JSON, 4xx/5xx, malformed) -> nothing at all. The badge must never show a broken state.
   Every value from the JSON goes in with textContent / setAttribute, never innerHTML, and links are only
   followed when they are https URLs. No Google logo and no "Google rating" wording on the hub badge. */
(function () {
  'use strict';
  var root = document.getElementById('hub-rvb');
  if (!root || root.getAttribute('data-hub-rvb-ready')) return;
  root.setAttribute('data-hub-rvb-ready', '1');

  var endpoint = root.getAttribute('data-endpoint') || '/apps/hub/reviews/summary.json';
  var storeName = root.getAttribute('data-store-name') || '';
  var seeAllUrl = root.getAttribute('data-see-all') || '';
  var gcrMerchant = root.getAttribute('data-gcr-merchant') || '';
  var nf = new Intl.NumberFormat('en');

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }
  function safeUrl(u) {
    return (typeof u === 'string' && /^https:\/\//i.test(u)) ? u : '';
  }
  function stars(n) {
    n = Math.max(0, Math.min(5, Math.round(+n || 0)));
    return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
  }
  function fmtDate(iso) {
    var d = new Date(String(iso || '') + 'T00:00:00Z');
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
  }
  function link(cls, text, href, newTab) {
    var a = el('a', cls, text);
    a.setAttribute('href', href);
    if (newTab) { a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener noreferrer'); }
    return a;
  }

  function mount(node) {
    root.textContent = '';
    root.appendChild(node);
    root.hidden = false;
  }

  /* 6d: below the per-store threshold the badge invites instead of rating */
  function renderInvite(d) {
    var url = safeUrl(d.review_url);
    if (!url) return;                               // nowhere to send them: show nothing
    var a = link('hub-rvb__pill hub-rvb__pill--invite', '', url, true);
    a.appendChild(el('span', 'hub-rvb__star', '★'));
    a.appendChild(el('span', 'hub-rvb__long', 'New on Google · review us'));
    a.appendChild(el('span', 'hub-rvb__short', 'Review us'));
    a.setAttribute('aria-label', 'Review us on Google (opens in a new tab)');
    mount(a);
  }

  function renderBadge(d) {
    var count = +d.count, avg = +d.average;
    var avgTxt = avg.toFixed(1);
    var countTxt = nf.format(count);
    var panelId = 'hub-rvb-panel';

    var wrap = el('div', 'hub-rvb__wrap');
    var pill = el('button', 'hub-rvb__pill');
    pill.type = 'button';
    pill.setAttribute('aria-expanded', 'false');
    pill.setAttribute('aria-controls', panelId);
    pill.setAttribute('aria-label', 'Customer reviews: ' + avgTxt + ' out of 5 from ' + countTxt + ' customers. Open details.');
    pill.appendChild(el('span', 'hub-rvb__star', '★'));
    pill.appendChild(el('span', 'hub-rvb__avg', avgTxt));
    pill.appendChild(el('span', 'hub-rvb__long', 'from ' + countTxt + ' customers'));
    pill.appendChild(el('span', 'hub-rvb__short', countTxt));

    var panel = el('div', 'hub-rvb__panel');
    panel.id = panelId;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Customer reviews');
    panel.hidden = true;

    panel.appendChild(el('div', 'hub-rvb__handle'));
    var hd = el('div', 'hub-rvb__hd');
    var head = el('div');
    var big = el('div', 'hub-rvb__big', avgTxt + ' ');
    big.appendChild(el('span', 'hub-rvb__stars', stars(avg)));
    head.appendChild(big);
    var src = d.sources || {};
    var onlyVerified = (+src.verified_buyers || 0) === count;
    head.appendChild(el('div', 'hub-rvb__sub',
      countTxt + (count === 1 ? ' review' : ' reviews') + (onlyVerified ? ' from verified buyers' : '') +
      (storeName ? ' · ' + storeName : '')));
    hd.appendChild(head);
    var x = el('button', 'hub-rvb__x', '×');
    x.type = 'button';
    x.setAttribute('aria-label', 'Close reviews');
    hd.appendChild(x);
    panel.appendChild(hd);

    var chips = el('div', 'hub-rvb__srcs');
    if (+src.verified_buyers > 0) chips.appendChild(el('span', 'hub-rvb__src', 'Verified buyers · ' + nf.format(src.verified_buyers)));
    chips.appendChild(el('span', 'hub-rvb__src', 'Google · ' + (+src.google > 0 ? nf.format(src.google) : '0 so far')));
    if (+src.product > 0) chips.appendChild(el('span', 'hub-rvb__src hub-rvb__src--opt', 'Product reviews · ' + nf.format(src.product)));
    panel.appendChild(chips);

    var hist = el('div', 'hub-rvb__hist');
    var h = d.histogram || {};
    [5, 4, 3, 2, 1].forEach(function (s) {
      var n = +h[s] || 0;
      hist.appendChild(el('span', '', s + '★'));
      var bar = el('div', 'hub-rvb__bar');
      var fill = el('i');
      fill.style.width = (count > 0 ? Math.max(n > 0 ? 1 : 0, Math.round(n * 100 / count)) : 0) + '%';
      bar.appendChild(fill);
      hist.appendChild(bar);
      hist.appendChild(el('span', '', nf.format(n)));
    });
    panel.appendChild(hist);

    (d.newest || []).slice(0, 3).forEach(function (r) {
      var rev = el('div', 'hub-rvb__rev');
      var m = el('div', 'hub-rvb__m');
      m.appendChild(el('span', '', String(r.name || 'A customer') + (r.city ? ' · ' + r.city : '')));
      var when = fmtDate(r.date);
      m.appendChild(el('span', 'hub-rvb__when', [when, r.source].filter(Boolean).join(' · ')));
      rev.appendChild(m);
      var t = el('div', 'hub-rvb__t');
      t.appendChild(el('span', 'hub-rvb__stars', stars(r.rating) + ' '));
      t.appendChild(document.createTextNode(String(r.text || '')));
      if (r.replied) t.appendChild(el('span', 'hub-rvb__chip', 'Replied'));
      rev.appendChild(t);
      panel.appendChild(rev);
    });

    var btns = el('div', 'hub-rvb__btns');
    var reviewUrl = safeUrl(d.review_url), profileUrl = safeUrl(d.profile_url);
    if (reviewUrl) btns.appendChild(link('hub-rvb__btn hub-rvb__btn--p', 'Review us on Google', reviewUrl, true));
    if (seeAllUrl) btns.appendChild(link('hub-rvb__btn hub-rvb__btn--s', 'See all reviews', seeAllUrl, false));
    panel.appendChild(btns);
    if (profileUrl) {
      var seeUs = link('hub-rvb__more', 'See us on Google', profileUrl, true);
      panel.appendChild(seeUs);
    }

    wrap.appendChild(panel);
    wrap.appendChild(pill);
    mount(wrap);

    function open() {
      panel.hidden = false;
      root.classList.add('hub-rvb--open');
      pill.hidden = true;
      pill.setAttribute('aria-expanded', 'true');
      x.focus({ preventScroll: true });
    }
    function close(refocus) {
      panel.hidden = true;
      root.classList.remove('hub-rvb--open');
      pill.hidden = false;
      pill.setAttribute('aria-expanded', 'false');
      panel.style.transform = '';
      if (refocus) pill.focus({ preventScroll: true });
    }
    pill.addEventListener('click', open);
    x.addEventListener('click', function () { close(true); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close(true);
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !wrap.contains(e.target)) close(false);
    });
    /* phone bottom sheet: drag the handle / header down to close */
    var y0 = null;
    panel.addEventListener('touchstart', function (e) {
      var t = e.target;
      if (t.closest && t.closest('.hub-rvb__handle, .hub-rvb__hd')) y0 = e.touches[0].clientY;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      var dy = e.touches[0].clientY - y0;
      if (dy > 0) panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function (e) {
      if (y0 === null) return;
      var dy = (e.changedTouches[0].clientY) - y0;
      y0 = null;
      if (dy > 70) close(true); else panel.style.transform = '';
    });
  }

  /* Google's own store widget: only when the hub says this store switched it on (off by default).
     Rendered INLINE into our own fixed container so it never fights the chat button. */
  function renderGoogleWidget(d) {
    if (d.google_widget !== true || !/^\d+$/.test(gcrMerchant)) return;
    var host = el('div', 'hub-rvb__gw');
    host.id = 'hub-rvb-gw';
    document.body.appendChild(host);
    window.renderBadge = function () {
      try {
        window.gapi.load('ratingbadge', function () {
          window.gapi.ratingbadge.render(host, { merchant_id: parseInt(gcrMerchant, 10), position: 'INLINE' });
        });
      } catch (e) { host.remove(); }
    };
    var s = document.createElement('script');
    s.src = 'https://apis.google.com/js/platform.js?onload=renderBadge';
    s.async = true; s.defer = true;
    document.head.appendChild(s);
  }

  var ctl = (typeof AbortController === 'function') ? new AbortController() : null;
  var timer = ctl ? setTimeout(function () { ctl.abort(); }, 8000) : null;
  fetch(endpoint, { credentials: 'omit', headers: { Accept: 'application/json' }, signal: ctl ? ctl.signal : undefined })
    .then(function (r) {
      var type = r.headers.get('content-type') || '';
      if (!r.ok || type.indexOf('json') === -1) throw new Error('unavailable');
      return r.json();
    })
    .then(function (d) {
      if (timer) clearTimeout(timer);
      if (!d || typeof d !== 'object' || typeof d.count !== 'number') return;
      var reached = d.threshold_reached === true && isFinite(+d.average) && d.average !== null;
      if (reached) renderBadge(d); else renderInvite(d);
      renderGoogleWidget(d);
    })
    .catch(function () { /* blocked or down: the badge simply does not appear */ });
})();
